import config from '../config';
import PauseResume from '../utils/PauseResume';
import LocalisationUtility from "../mp/LocalisationUtility";

class Boot extends Phaser.Scene {
  init () {
    let g = this;
    // apply our styles defined in the head of index.html
    g.sys.game.canvas.classList.add('game-canvas');

    // initialize our global pause and resume functionality
    g.sys.game.dataManager.setSessionItem(config.BASE_SCENE, 'Boot');
    PauseResume(g.sys.game);
  }
  preload () {
    let g = this;
    const RES = config.RESOLUTION;
    // Load Assets for the preloader screen
    g.load.path = config.MEDIA_IMAGE_PATH;
    g.load.image('loader-bg', 'loader/bg.jpg');
    g.load.image('boot-logo', 'loader/cn-logo.png');

    g.load.path = "";
    g.load.json("config", "config.json");
    g.load.json("localisation", "media/localisation.json");
  }
  create () {
    // console.log('Boot.create');
    let g = this;
    g.sys.game.mpConfig = g.cache.json.get("config");
    g.sys.game.localis = new LocalisationUtility(this.game, "localisation", g.sys.game.mpConfig.language);
    window.orientationChecker.SetGame(this.game);

    WebFont.load({
      active: this.OnWebFontLoaded.bind(this),
      custom: {
        families: [
          "FredBurger Black"
        ],
        urls: [
          g.sys.game.localis.language != "ar" ? "media/fonts/fredburger.css" : "media/fonts/fredburger_arabic.css"
        ],
      }
    });
  }

  OnWebFontLoaded () {
    let g = this;
    g.sys.game.localis.mainFont = "FredBurger Black";
    g.scene.start('Preload');
  }
}

export default Boot;
